export const formattDate = (date) => {
  let data_americana = date.split("/").reverse().join("-");
  return data_americana;
};

export const formattDatePt = (date) => {
  let data = date.split("-").reverse().join("/");
  return data;
};
